export default __webpack_public_path__ + "static/media/topic-slideout.d876f5d0.jpg";